import styled from 'styled-components';
import { fontSizes, fontWeights, lineHeights } from '../../defaultTheme';
const H1 = styled.h1 `
  font-size: ${fontSizes.xxxLarge}px;
  line-height: ${lineHeights.root};
  font-weight: ${({ weight }) => fontWeights[weight || 'regular']};
  margin: 0;

  &:focus {
    outline: none;
  }
`;
export default H1;
//# sourceMappingURL=H1.js.map